import array from '@mailobj-browser/front/js/utils/array.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import preventDefault
  from '@mailobj-browser/front/js/events/hooks/preventDefault.js'
import stopImmediatePropagation
  from '@mailobj-browser/front/js/events/hooks/stopImmediatePropagation.js'
import { modifiers } from '../../styles.js'
import {
  tapUp
} from '@mailobj-browser/front/js/events/listeners/builtins/tap.js'

const bubbling = object(null, {
  bubbles: true
})

const onTapUp = object(tapUp, {
  hooks: array([
    stopImmediatePropagation
  ]),
  task: (
    cell,
    event
  ) => {
    if (cell.classList.contains(modifiers.table_tbody_cell.listenable)) {
      const { parentNode, ownerDocument } = cell
      const { defaultView } = ownerDocument
      const { InputEvent } = defaultView
      const checkbox = one(`input[type="checkbox"]`, parentNode)

      preventDefault(event)
      checkbox.checked = !checkbox.checked
      checkbox.indeterminate = false
      checkbox.dispatchEvent(new InputEvent('input', bubbling))
    }
  }
})

export default (
  cell
) => {
  onTapUp.listen(cell)
}
